import axiosInstance from '../api';
import { notification } from 'antd';


export const fetchPrivacyPolicy = async () => {
    try {
      const response = await axiosInstance.post(`/list/get_privacy_policy`);
      if(response?.data?.status_code === 200){
        return response?.data?.data;
      }
      notification.error({
        message: "Error Fetching ",
        description: response?.data?.message || "Failed to fetch.",
        duration: 3,
      });
      return []
     
    } catch (error) {
      console.error("Error fetching details", error);
      throw new Error("Error fetching details");
    }
  };

  export const fetchTermsAndConditions = async () => {
    try {
      const response = await axiosInstance.post(`/list/get_term_condition`);
      if(response?.data?.status_code === 200){
        return response?.data?.data;
      }
      notification.error({
        message: "Error Fetching ",
        description: response?.data?.message || "Failed to fetch.",
        duration: 3,
      });
      return []
     
    } catch (error) {
      console.error("Error fetching details", error);
      throw new Error("Error fetching details");
    }
  };

export const updatePrivacyPolicy = async (value) => {
    try {

      const formData = new FormData();
      formData.append("file", new Blob([value.value], { type: "text/plain" }));
      
      const response = await axiosInstance.post("/list/update_privacy_policy", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      
  
      if (response.data.status_code === 200) {
        notification.success({
          message: "Success",
          description: response.data.message,
          duration: 3,
        });
        return response.data.data;
      } else {
        notification.error({
          message: "Update Error",
          description: response.data.message || "An error occurred during update.",
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Update Failed",
        description: error.response?.data?.message || "An unexpected error occurred.",
        duration: 3,
      });
      throw new Error(error.response?.data?.message || "Error updating privacy policy");
    }
  };

  export const updateTermsAndConditions = async (value) => {
    try {

      const formData = new FormData();
      formData.append("file", new Blob([value.value], { type: "text/plain" }));
      
      const response = await axiosInstance.post("/list/update_term_condition", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      
  
      if (response.data.status_code === 200) {
        notification.success({
          message: "Success",
          description: response.data.message,
          duration: 3,
        });
        return response.data.data;
      } else {
        notification.error({
          message: "Update Error",
          description: response.data.message || "An error occurred during update.",
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Update Failed",
        description: error.response?.data?.message || "An unexpected error occurred.",
        duration: 3,
      });
      throw new Error(error.response?.data?.message || "Error updating privacy policy");
    }
  };

  export const fetchAppPages = async () => {
    try {
      const response = await axiosInstance.post(`/list/app_pages`);
      if(response?.data?.status_code === 200){
        return response?.data?.data;
      }
      notification.error({
        message: "Error Fetching ",
        description: response?.data?.message || "Failed to fetch.",
        duration: 3,
      });
      return []
     
    } catch (error) {
      console.error("Error fetching details", error);
      throw new Error("Error fetching details");
    }
  };